import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import "@css/pages/employer/DocumentsEmployers/courseCertifications.css";
import "@css/pages/employer/listeEmployer.css";
import EmptyData from "@components/tailwindComponents/EmptyData";
import CertificationListItem from "./CertificationListItem";
import DotLoader from "@components/tailwindComponents/DotLoader";

const CertificationList = ({ certifications, idEmployer, isReadOnly, isEnterprisePage, userConnected , isLoading}) => {
  const { t } = useTranslation("pages.employés.parcours&Certifications");

  return !certifications?.length ? (
    <EmptyData>
      {t("Aucun permis ou certification à afficher pour cet employé")}
    </EmptyData>
  ) : (
    <div className="arh-w-full">
      <table className="arh-w-full arh-table-fixed arh-font-poppins">
        <thead className="arh-bg-greyColor">
          <tr>
            <th className="arh-w-[14%] arh-px-2 arh-py-3 arh-font-semibold arh-text-xs arh-text-black">
              {t("Nom certification")}
            </th>
            <th className="arh-w-[15%] arh-px-2 arh-py-3 arh-font-semibold arh-text-xs arh-text-black">
              {t("Date d'obtention")}
            </th> 
            <th className="arh-w-[15%] arh-px-2 arh-py-3 arh-font-semibold arh-text-xs arh-text-black">
              {t("Date de fin de validité")}
            </th>
            <th className="arh-w-[9%] arh-px-2 arh-py-3 arh-font-semibold arh-text-xs arh-text-black">
              {t("Note")}
            </th>
            <th className="arh-w-[15%] arh-px-2 arh-py-3 arh-font-semibold arh-text-xs arh-text-black">
              {t("Fichier joint")}
            </th>
            <th className="arh-w-[15%] arh-px-2 arh-py-3 arh-font-semibold arh-text-xs arh-text-black">
              {t("Alerte")}
            </th>
            <th className="arh-w-[5%] arh-px-2 arh-py-3 arh-font-semibold arh-text-xs arh-text-black"></th>
          </tr>
        </thead>
        <tbody>
          {
          isLoading ? 
          (
            <tr>
              <td colSpan={11}>
                <div className="arh-h-[20dvh]">
                  <DotLoader size="small" />
                </div>
              </td>
            </tr>
          ) : 
          certifications.map((data) => (
            <CertificationListItem
              key={data._id}
              certification={data}
              idEmployer={idEmployer}
              isReadOnly={isReadOnly}
              isEnterprisePage={isEnterprisePage}
              userConnected={userConnected}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default memo(CertificationList);
